import Vue from "vue";
import VueI18n, { DateTimeFormats, Locale, Path } from "vue-i18n";
import _ from "lodash";

Vue.use(VueI18n);

export const defaultLanguage = "hr-HR";
export const supportedLanguages = ["hr-HR", "en-GB", "sl-SI"];

// let refDispatch: Promise<any> | undefined;
const dispatch = _.debounce(
  (locale: Locale, key: Path, vm: Vue | null) => {
    vm?.$store.dispatch("language/setLanguage", vm.$i18n.locale);
  },
  30 * 1000,
  { leading: true, trailing: false }
);

const dateTimeFormats: DateTimeFormats = {
  'hr-HR': {
    "year": {
      year: 'numeric',
    },
    "month": {
      year: 'numeric',
      month: 'numeric',
    },
    'long': {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    'precise': {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      fractionalSecondDigits: 3
    },
    'minute': {
      hour: 'numeric',
      minute: 'numeric',
    }
  },
  'en-GB': {
    "year": {
      year: 'numeric',
    },
    "month": {
      year: 'numeric',
      month: 'numeric',
    },
    'long': {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    'precise': {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      fractionalSecondDigits: 3
    },
    'minute': {
      hour: 'numeric',
      minute: 'numeric',
    }
  },
  'sl-SI': {
    "year": {
      year: 'numeric',
    },
    "month": {
      year: 'numeric',
      month: 'numeric',
    },
    'long': {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    'precise': {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      fractionalSecondDigits: 3
    },
    'minute': {
      hour: 'numeric',
      minute: 'numeric',
    }
  }
};

const i18n = new VueI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  dateTimeFormats: dateTimeFormats,
  pluralizationRules: {
    "hr-HR": function (choice) {
      const c = Math.abs(choice);

      if (c <= 1) {
        return c;
      }

      const doesntEndWith11 = c % 100 !== 11;
      const endsWith1 = c % 10 === 1;

      if (doesntEndWith11 && endsWith1) {
        return 1;
      }

      return 2;
    },
  },
  missing: (locale: Locale, key: Path, vm: Vue | null) => {
    dispatch(locale, key, vm);
    return key;
  },
});

export default i18n;
